module.exports = __webpack_public_path__ + "img/xy1@2x.2e822059.png";